<script lang="ts">
	import { Toaster as SonnerToaster } from '../components/ui/sonner';
	import { onMount } from 'svelte';

	let wrapper: HTMLDivElement;

	onMount(() => {
		document.body.appendChild(wrapper);
		return () => wrapper?.remove();
	});
</script>

<div
	bind:this={wrapper}
	style="position: fixed; z-index: 2147483647; pointer-events: none;"
>
	<div style="pointer-events: auto;">
		<SonnerToaster
			position="bottom-right"
			richColors
			closeButton
			style="--toast-close-button-start: unset; --toast-close-button-end: 0; --toast-close-button-transform: translate(35%, -35%);"
		/>
	</div>
</div>

<style>
	:global([data-sonner-toast] [data-title]),
	:global([data-sonner-toast] [data-description]) {
		white-space: pre-line;
	}
</style>
